export enum ProviderType {
  KBZ = 'KBZ',
  WAVE = 'WAVE',
  AYA = 'AYA',
  Phone_Bill = 'PB',
}
